﻿import { defineComponent } from 'vue';

import documentation_item from "./documentation_item.vue";
import { document } from '../../../objects/v1_2/Booking_Details/document';

import { Booking } from "../../../services/booking";
import { booking_search_group } from "../../../objects/v1_2/Booking_Details/booking_search_group";

let Book: Booking = new Booking(); 

export default defineComponent({
    name: "documentation",
    components: {
        documentation_item
    },
    props: {
    },
    data() {
        return {
           
        }
    },
    methods: {
        get_Booking(): booking_search_group {
            return this.$store.getters.get_Booking;
        },
        get_documents(): document[] {
            let outdocs : document[] = [];
            let docs = this.get_Booking().documents;
            docs.forEach( doc => {
                let newdoc: document = new document();
                newdoc.name = doc.name;
                newdoc.url = doc.url;
                outdocs.push(newdoc);
            });
            return outdocs;
        }
    },
    mounted() {
    }
})